/* eslint-disable react/prop-types */
import React, { FC } from 'react';
import FooterPoweredByLogoBlock, { FooterPoweredByLogoBlockProps } from '../FooterPoweredByLogoBlock';
import FooterPrivacyAndCookiePolicy, { FooterPrivacyAndCookiePolicyProps } from '../FooterPrivacyAndCookiePolicy';
import GooglePrivacyPolicy, { GooglePrivacyPolicyProps } from '../GooglePrivacyPolicy';
import useStyles from './useStyles';

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface FooterContainerProps
  extends FooterPoweredByLogoBlockProps,
    FooterPrivacyAndCookiePolicyProps,
    GooglePrivacyPolicyProps {
  /** A prop to render the google privacy policy component */
  isGoogleSubdomain: boolean;
  /** Boolean prop to show privacy and cookie policy anchor elements */
  showPrivacyCookiePolicy: boolean;
  /** An optional boolean prop to determine if the footer container renders everything in a footer or div html element. Defaults to true if no value is provided. */
  isFooter?: boolean;
}

type WrapperProps = {
  isFooter: boolean;
  children: React.ReactNode;
};

function Wrapper({ isFooter, children }: WrapperProps): React.ReactElement {
  if (isFooter) {
    return <footer>{children}</footer>;
  }
  return <div>{children}</div>;
}

const FooterContainer: FC<FooterContainerProps> = ({
  isGrayScale,
  surveyMonkeyURL,
  howItWorksURL,
  privacyURL,
  cookiePolicyURL,
  showReportProblem,
  reportProblemURL,
  isGoogleSubdomain,
  googlePrivacyPolicyURL,
  showPrivacyCookiePolicy,
  isFooter = true,
}) => {
  const { privacyComponentContainer } = useStyles();

  return (
    <Wrapper isFooter={isFooter}>
      <FooterPoweredByLogoBlock {...{ isGrayScale, surveyMonkeyURL, howItWorksURL }} />
      {isGoogleSubdomain && <GooglePrivacyPolicy {...{ googlePrivacyPolicyURL }} />}
      {showPrivacyCookiePolicy && (
        <div className={privacyComponentContainer}>
          <FooterPrivacyAndCookiePolicy {...{ privacyURL, cookiePolicyURL, showReportProblem, reportProblemURL }} />
        </div>
      )}
    </Wrapper>
  );
};
export default FooterContainer;
